<!-- 禁止类商品 -->
 <template> 
    <div>
        <div class="flex_box">
            <el-form :inline="true" :model="formSeacher" class="demo-form-inline" size="mini"  label-width="100px">
                <el-form-item label="海关编码">
                    <el-input v-model="formSeacher.hsCode" clearable placeholder="请输入海关编码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="onSubmit">查询</el-button>
                    <el-button type="success" plain @click="addClass">新增</el-button>
                </el-form-item>
            </el-form>
            <div style="flex: 1;">
                <el-table  :data="tableList" :header-cell-style="{'text-align':'center'}" height="100%" >
                    <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
                    <el-table-column label="海关编码" prop="hsCode" align="center"> </el-table-column>
                    <el-table-column label="禁止理由" prop="reason" align="center"> </el-table-column>
                    <el-table-column label=""  align="center"> 
                        <template slot-scope="scope">
                            <el-button  @click="exitClass(scope.row)" type="primary" plain size="mini">编辑</el-button>
                            <el-button type="danger" plain size="mini" @click="delClass(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
           
        </div>
        <!-- 新增、编辑禁止类商品 -->
        <el-dialog :title="classForm.id === '' ? '新增禁止类商品':'编辑禁止类商品'" :visible.sync="classDialog">
            <el-form :model="classForm" ref="classForm" class="demo-form-inline" size="mini" :rules="rules" label-width="100px" >
                <el-form-item label="海关编码" prop="hsCode">
                    <el-input v-model="classForm.hsCode" clearable placeholder="请输入海关编码"></el-input>
                </el-form-item>
                 <el-form-item label="禁止理由" prop="reason">
                    <el-input v-model="classForm.reason" clearable placeholder="请输入禁止理由"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="success" plain @click="save">保存</el-button>
                <el-button size="mini" type="primary" plain @click="cancel">取消</el-button>
            </span>
        </el-dialog>
    </div>
 </template>
 <script>

 
 export default {
    name: 'prohibitedClass',
    data() {
        return {
            formSeacher:{
                hsCode:''
            },
            classForm:{
                id:'',
                hsCode:'',
                reason:'',
            },
            tableList: [],
            classDialog:false,
            rules:{
                hsCode: [
                    { required: true, message: '请输入海关编码',trigger: 'blur' },
                ],
                reason: [
                    { required: true, message: '请输入禁止理由',trigger: 'blur' },
                ]
            }
        }
    },
    mounted() { 
        this.onSubmit()
    },
    methods: {
        onSubmit(){
            const params = {
                hsCode: this.formSeacher.hsCode
            }
            this.$api.getProhibitGoods(  params ).then(res =>{
                this.tableList = res
            })
        },
        addClass(){
            this.classForm={
                id:'',
                hsCode:'',
                reason:'',
            },
            this.classDialog = true
        },
        exitClass(item){
            this.classForm = item
            this.classDialog = true
        },
        save(){
            this.$refs.classForm.validate(valid => {
                if (valid) {
                    this.$api.saveOrUpdateProhibitGood(this.classForm).then(res =>{
                        this.classDialog = false
                        this.onSubmit()
                    })
                }
            })
        },
        delClass(item){
            this.$confirm('是否删除此禁止类商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const id = item.id
                this.$api.deleteProhibitGood(id).then(res =>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.classDialog = false
                    this.onSubmit()
                })
            }).catch(() => {});
        },
        cancel(){
            this.classDialog = false
            this.classForm={
                id:'',
                hsCode:'',
                reason:'',
            }
        },
    }
 }
 </script>
 <style lang="css" scoped>
.el-table {
    margin-top: -10px;
}
.flex_box{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 85px);
}
 </style>